module.exports = __webpack_public_path__ + "static/media/onboarding_bigcommerce.200f2387.svg";